import BrokerWiseBrokerLogo from './BrokerWiseBrokerLogo';

export default BrokerWiseBrokerLogo;
